export enum ERouteNamespace {
  ADMIN = 'admin',
  AFFILIATE = 'affiliate',
  ANONYMOUS = 'anonymous',
  ROOT = 'root',
  ANY = 'any',
}
